<template>
  <div class="criteria-assessment-rubic-wrapper">
    <!-- Assessment Rubric -->
    <div class="collapse-wrapper">
      <div v-b-toggle="`collapse-assessment-${criterion.id}`" class="collapse-header">
        <span> Assessment Rubric </span>
        <svg
          class="icon-expanded"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.29609 11.2086C7.68672 11.5992 8.32109 11.5992 8.71172 11.2086L13.7117 6.20859C14.1023 5.81797 14.1023 5.18359 13.7117 4.79297C13.3211 4.40234 12.6867 4.40234 12.2961 4.79297L8.00234 9.08672L3.70859 4.79609C3.31797 4.40547 2.68359 4.40547 2.29297 4.79609C1.90234 5.18672 1.90234 5.82109 2.29297 6.21172L7.29297 11.2117L7.29609 11.2086Z"
            fill="#3B3E66"
          />
        </svg>
      </div>

      <b-collapse :id="`collapse-assessment-${criterion.id}`" class="collapse-body">
        <div class="collapse-content">
          <div class="collapse-content__rubric">
            <!-- Pass -->
            <div class="text__criterion">
              <div>
                <svg
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                  class="text-info"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z"
                  ></path>
                </svg>
              </div>
              <div class="text__criterion-title">
                <b>
                  {{ criterion.pass_title }}
                </b>
                <p class="m-0 text__criteria-description">{{ criterion.pass_criterion }}</p>
              </div>
            </div>

            <div
              v-for="additional in criterion.additional_criteria"
              :key="`additional-${additional.id}`"
              class="text__criterion"
            >
              <div>
                <svg
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="text-warning"
                >
                  <path
                    d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"
                  ></path>
                </svg>
              </div>
              <div class="text__criterion-title">
                <b>
                  {{ additional.title }}
                </b>
                <p class="m-0 text__criteria-description">{{ additional.description }}</p>
              </div>
            </div>

            <!-- Not Yet -->
            <div class="text__criterion">
              <div>
                <svg
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="text-danger"
                >
                  <path
                    d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"
                  ></path>
                </svg>
              </div>
              <div class="text__criterion-title">
                <b>
                  {{ criterion.not_yet_title }}
                </b>
                <p class="m-0 text__criteria-description">{{ criterion.not_yet_criterion }}</p>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { Criteria } from '@/models/Criteria';

export default {
  name: 'CriteriaAssessmentRubic',

  props: {
    criterion: {
      type: Criteria,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.criteria-assessment-rubic-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .text__criteria-description {
    white-space: pre-line;
    word-break: break-word;
  }

  .collapse-wrapper {
    cursor: pointer;
    border-radius: 10.4px;
    border: 1px solid #d1d2db;
    overflow: hidden;

    .badge-text-info {
      color: #0c6b7e;
    }

    .background-info {
      color: #3b3e66;
      background-color: #cff3f8;
    }

    .badge-text-warning,
    .background-warning {
      color: #824224;
    }

    .background-warning {
      background-color: #fde4d5;
    }

    .badge-text-danger,
    .background-danger {
      color: #841e30;
    }

    .background-danger {
      background-color: #fed6da;
    }

    .header__feedback-from-assessor {
      background-color: #d9e9ff;
      color: #255091;
    }
  }

  .collapse-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
    font-weight: bold;

    .collapse-header__title {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .collapse-header__status {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 1.25rem;

      .criterion-evaluation {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.5rem;
        padding: 9px 12px;
        font-size: 12px;
        line-height: 0;
        word-wrap: break-word;
        overflow-wrap: break-word;
        height: auto;
        border-radius: 10rem;
        background: #ffffff;

        span {
          word-wrap: break-word;
          overflow-wrap: break-word;
          white-space: normal;
          text-transform: uppercase;
        }
      }
    }
  }

  .collapse-body {
    border-top: 1px solid #d1d2db;
  }

  .collapse-content {
    display: flex;
    flex-direction: column;
    padding: 16px 20px;

    .ql-editor--display {
      padding: 0;
      margin: 0;
    }

    .content-text + .content-file-list {
      margin-top: 0.75rem;
    }
  }
  .collapse-content__rubric {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .collapse-body.show {
    padding: 0;
  }

  .not-collapsed .icon-expanded {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
  }

  .collapsed .icon-expanded {
    transition: transform 0.3s ease;
  }

  .text__criterion {
    display: flex;
    gap: 1rem;
    width: 100%;
  }
}
</style>
